// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"A_AU_TheComp__oms0K"};